// extracted by mini-css-extract-plugin
module.exports = {"LessonTour":"frontend-components-trial-common-styles-Tour__LessonTour--1SS0q","tourContent":"frontend-components-trial-common-styles-Tour__tourContent--1R-sY"};